import * as Sentry from '@sentry/react';
import { CaptureContext, SeverityLevel } from '@sentry/types';

interface IProps {
  name: string;
  context: CaptureContext | SeverityLevel | null;
  isError?: boolean;
}
export const sendSentryMessage = (props: IProps): void => {
    const { name, context, isError = true } = props;

  // @ts-ignore
    if (context?.status === 401 || context?.statusCode === 401 || context?.message === 'Request failed with status code 401' || context?.response?.data === 'Request failed with status code 401') return;

  if (process.env.REACT_APP_ENVIRONMENT !== 'development' && process.env.REACT_APP_ENVIRONMENT !== 'staging') {
    try {
      // @ts-ignore
      if (isError && context?.message) {
        // @ts-ignore
        Sentry.setTag('error-message', context?.message);
      }

      // @ts-ignore
      if (isError && context?.response?.data) {
        // @ts-ignore
        Sentry.setTag('error-message', context?.response?.data);
      }

      Sentry.captureMessage('Portal: ' + name);
    } catch (e) {
      console.error('Sentry error', e);
    }
  }
};

